import type { ReactElement } from 'react';

import { COLUMNS } from './TrainingTable';
import { SKELETON_CYCLE, skeletonLine } from '@/components/ui/skeleton';

/** Skeleton contextual con la forma real de la pantalla (UX-LOAD-01): la tabla de
 *  documentos y el detalle, no un spinner. */
export function TrainingSkeleton(): ReactElement {
  return (
    <div
      className="g-2"
      style={{ marginTop: 16 }}
      aria-busy="true"
      aria-label="Cargando capacitaciones"
    >
      <div className="card rise d2">
        <div className="ch">
          <h3>Capacitaciones por documento</h3>
        </div>
        <table className="t">
          <thead>
            <tr>
              {COLUMNS.map((c) => (
                <th key={c}>{c === 'Estado' ? '' : c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 6 }).map((_, r) => (
              <tr key={r}>
                {COLUMNS.map((c, i) => (
                  <td key={c}>
                    <div className={skeletonLine({ width: i === 0 ? 'sm' : 60 })} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="card rise d3">
        <div className="ch">
          <h3>Detalle</h3>
        </div>
        <div className="cb">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className={skeletonLine({
                width: SKELETON_CYCLE[i % SKELETON_CYCLE.length],
                ...(i > 0 ? { space: 'top' } : {}),
              })}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
